import React, { useEffect } from "react";
import HeroSection from "./HeroSection";

function HomePage({ language = "EN" }) {
  useEffect(() => {
    document.body.classList.add("home-hero-only");
    return () => {
      document.body.classList.remove("home-hero-only");
    };
  }, []);
  return <HeroSection language={language} />;
}

export default HomePage;
